module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av170-ce16f5e5291df54467c55df5f6996dd2.jpg";